import { DiagramValidationError, DiagramValidator } from './DiagramValidator';

import { DiagramComponentInstance } from './DiagramComponentInstance';
import { Diagram } from './Diagram';

export enum ComponentInstanceValidationErrorType {
    CONTROL_METHODS_MISSING = 'CONTROL_METHODS_MISSING',
    CONTROL_METHODS_TOO_MANY = 'CONTROL_METHODS_TOO_MANY',
    CORE_SPECIFICATIONS_CURRENT = 'CORE_SPECIFICATIONS_CURRENT',
    CORE_SPECIFICATIONS_POWER = 'CORE_SPECIFICATIONS_POWER',
    CORE_SPECIFICATIONS_VOLTAGE = 'CORE_SPECIFICATIONS_VOLTAGE',
    PROTECTION_DIRECTION_BIDIRECTIONAL_ON_UNIDIRECTIONAL_FLOW = 'PROTECTION_DIRECTION_BIDIRECTIONAL_ON_UNIDIRECTIONAL_FLOW',
    REQUIRED_CONFIGURATION_BATTERY_VOLTAGE = 'REQUIRED_CONFIGURATION_BATTERY_VOLTAGE',
    REQUIRED_CONFIGURATION_BUS_GROUNDING_IMPEDANCE = 'REQUIRED_CONFIGURATION_BUS_GROUNDING_IMPEDANCE',
    INVALID_CONFIGURATION_BUS_GROUNDING_SYMMETRY = 'INVALID_CONFIGURATION_BUS_GROUNDING_SYMMETRY',
    INVALID_CONFIGURATION_DC_PORT_LINES = 'INVALID_CONFIGURATION_DC_PORT_LINES',
    REQUIRED_CONFIGURATION_CONVERTER_VOLTAGE = 'REQUIRED_CONFIGURATION_CONVERTER_VOLTAGE',
    REQUIRED_CONFIGURATION_CONVERTER_DROOP_RESISTANCE = 'REQUIRED_CONFIGURATION_CONVERTER_DROOP_RESISTANCE',
    REQUIRED_CONFIGURATION_GENERATOR_VOLTAGE = 'REQUIRED_CONFIGURATION_GENERATOR_VOLTAGE',
    REQUIRED_CONFIGURATION_UTILITY_VOLTAGE = 'REQUIRED_CONFIGURATION_UTILITY_VOLTAGE',
    REQUIRED_CONFIGURATION_POWER_VOLTAGE_DROOP = 'REQUIRED_CONFIGURATION_POWER_VOLTAGE_DROOP',
    INVALID_CONFIGURATION_STATE_OF_CHARGE_DERATING_COMPONENT = 'INVALID_CONFIGURATION_STATE_OF_CHARGE_DERATING_COMPONENT',
    INVALID_CONFIGURATION_STATE_OF_CHARGE_DERATING_MPPT = 'INVALID_CONFIGURATION_STATE_OF_CHARGE_DERATING_MPPT',
    INVALID_CONFIGURATION_STATE_OF_CHARGE_DERATING_SOURCE = 'INVALID_CONFIGURATION_STATE_OF_CHARGE_DERATING_SOURCE',
    REQUIRED_CONFIGURATION_STATE_OF_CHARGE_DERATING_BATTERY = 'REQUIRED_CONFIGURATION_STATE_OF_CHARGE_DERATING_BATTERY',
    INVALID_CONFIGURATION_STATE_OF_CHARGE_DERATING_BATTERIES = 'INVALID_CONFIGURATION_STATE_OF_CHARGE_DERATING_BATTERIES',
}

export type ComponentInstanceValidationError = DiagramValidationError<
    ComponentInstanceValidationErrorType,
    {
        componentInstance: DiagramComponentInstance;
        portIndex?: number;
    }
>;

export type ComponentInstanceValidator = DiagramValidator<
    'componentInstance',
    { diagram: Diagram },
    ComponentInstanceValidationError,
    ComponentInstanceValidationErrorType
>;
